/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostOrdersReportMutationResponse, PostOrdersReportQueryParams, PostOrdersReport400 } from "../entities/PostOrdersReport";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { postOrdersReport } from "../api/postOrdersReport";
import { useMutation } from "@tanstack/react-query";

export const postOrdersReportMutationKey = () => [{ url: '/orders/report' }] as const

export type PostOrdersReportMutationKey = ReturnType<typeof postOrdersReportMutationKey>

/**
 * @description Получение отчета по поездкам Dostavkee
 * @summary Получение отчета по поездкам Dostavkee
 * {@link /orders/report}
 */
export function usePostOrdersReport<TContext>(options: 
{
  mutation?: UseMutationOptions<PostOrdersReportMutationResponse, ResponseErrorConfig<PostOrdersReport400>, {params: PostOrdersReportQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postOrdersReportMutationKey()

  return useMutation<PostOrdersReportMutationResponse, ResponseErrorConfig<PostOrdersReport400>, {params: PostOrdersReportQueryParams}, TContext>({
    mutationFn: async({ params }) => {
      return postOrdersReport(params, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}